import { Injectable, inject } from '@angular/core';
import { shareReplay } from 'rxjs/operators';
import { Client } from '../api/api-clientInformation';

@Injectable({ providedIn: 'root' })
export class DictionariesService {
  private readonly apiClient = inject(Client);

  readonly mciPrograms$ = this.apiClient.getMciPrograms().pipe(shareReplay(1));
  readonly financeStatuses$ = this.apiClient.getFinanceStatuses().pipe(shareReplay(1));
}
